// extracted by mini-css-extract-plugin
export default {"recommendationTextLinks":"RecommendationsTextLinksLayout_recommendationTextLinks__Ffv7U"};